mutation ApprovalSetupApprovalCreate(
  $input: ApprovalSetupApprovalCreateInput!
) {
  approvalSetupApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
